export const beersInfo = [
  {
    name: 'djeneral',
    title: '\\eneral',
    subtitle: 'Pivo sa ukusom slobode',
    taste: 'slobode',
    alcohol: '4.8',
    beerStyle: 'lager',
    style: 'text-white',
    // description:
    //   'Inspirisano `ivotom i delom \\enerala Dragoquba Mihailovi&#125;a nastalo je \\eneral pivo. Kombinovawem najkvalitetnijih prirodnih sastojaka dobili smo pitki lager sa prijatnom gorinom koji savr&#123;eno opisuje ~i~inu blagu narav i jak karakter, a zlatna boja predstavqa slobodu koju  treba ceniti vi&#123;e i od samog zlata.',
    description:
      'Инспирисано животом и делом Ђенерала Драгољуба Михаиловића настало је Ђенерал пиво. Комбинујући најквалитетније природне састојке, добили смо питки лагер са пријатном горчином који савршено описује Чичину благу нарав и јак карактер, а златна боја представља слободу коју треба ценити више и од самог злата.',
    titleStyle: 'bg-gradient-to-r from-yellow-400 to-yellow-800 ',
    textColor: 'text-yellow-400',
    buttonStyle:
      'bg-gradient-to-r hover:from-yellow-500 hover:to-yellow-800 border-2 border-yellow-500',
    buttonDisabled: false,
    link: 'https://prodajapica.rs/prodaja-piva/djeneral-pivo-33cl/',
  },
  {
    name: 'tango',
    title: 'Tango',
    subtitle: 'Pivo sa ukusom pravde',
    taste: 'pravde',
    alcohol: '5.2',
    beerStyle: 'apa',
    // description:
    //   'Kao i argentinski tango, na&#123; Argentinski Pale Ale nosi strast i emociju. Svaki gutljaj ovog ekstremno pitkog piva sa aromama citrusa otkriva strogo ~uvane tajne ulica Buenos Airesa za kojima je tragao na&#123; neustra&#123;ivi junak Blagoje Jovovi&#125;. Za tango je potrebno dvoje, a za pravdu Blagoju su trebala dva metka za Paveli&#125;a.',
    description:
      'Као и аргентински танго, наш Аргентински Пејл Ајл носи страст и емоцију. Сваки гутљај овог изузетно питког пива са аромама цитруса открива строго чуване тајне улица Буенос Ајреса за којима је трагао наш неустрашиви јунак Благоје Јововић. За танго је потребно двоје, а за правду Благоју су била довољна два метка за Павелића.',
    titleStyle: 'bg-gradient-to-r from-blue-400  to-blue-800',
    textColor: 'text-blue-400',
    buttonStyle:
      'bg-gradient-to-r hover:from-blue-500 hover:to-blue-800 border-2 border-blue-500',
    buttonDisabled: false,
    link: 'https://prodajapica.rs/prodaja-piva/tango-pivo-33cl/',
  },
];

export const locations = [
  {
    name: 'Бела Гарда',
    mapName: 'Bela Garda',
    city: 'Темерин',
    mapCity: 'Petefi sandora 98',
    address: 'Петефи Шандора 98',
    phone: '011 4558421',
    latLong: [45.409815622772385, 19.876838400036526],
    workTime: 'Пон - Нед: 08:00 - 23:00',
    isOnline: false,
  },
  {
    name: 'Енерги Стар',
    mapName: 'Energy Star International',
    city: 'Београд',
    mapCity: 'Bezanijski zimovnik 1a',
    address: 'Бежанијски зимовник 1а',
    phone: '063/568-155',
    latLong: [44.798013201060314, 20.423066433784467],
    workTime: '24/7',
    isOnline: true,
  },
];
